import { Box, Heading, StyledIcon, TextBlock } from "@bcc-ui/ui-components";
import classNames from "classnames";
import React from "react";

import style from "./grade-badge.scss";
import { Grade } from "domain/grade";
import { resolveColor } from "utils/commonFunctions";

export const NO_GRADE = "NO_GRADE";

type BadgeGrade = Grade | typeof NO_GRADE;

const BADGE_COLOR: Record<BadgeGrade, string> = {
    A: "--app-first-grade-badge-color",
    B: "--app-second-grade-badge-color",
    C: "--app-third-grade-badge-color",
    D: "--app-fourth-grade-badge-color",
    [NO_GRADE]: "--app-no-grade-badge-color",
};

const BADGE_BACKGROUND_COLOR: Record<BadgeGrade, string> = {
    A: "--app-first-grade-badge-backgroundColor",
    B: "--app-second-grade-badge-backgroundColor",
    C: "--app-third-grade-badge-backgroundColor",
    D: "--app-fourth-grade-badge-backgroundColor",
    [NO_GRADE]: "--app-no-grade-badge-backgroundColor",
};

interface Props {
    grade: BadgeGrade;
    size?: number;
    bold?: boolean;
    withBackground?: boolean;
    title?: string;
    description?: string;
    trailingContent?: React.ReactNode;
}

export const GradeBadge = (props: Props) => {
    const badgeColor = BADGE_COLOR[props.grade];
    const badgeBackgroundColor = BADGE_BACKGROUND_COLOR[props.grade];
    return (
        <Box
            className={classNames({ [style.background]: props.withBackground })}
            style={{ background: props.withBackground ? resolveColor(badgeBackgroundColor) : undefined }}
        >
            {props.grade !== NO_GRADE && (
                <StyledIcon
                    icon={
                        <div className={classNames(style.gradeText, { [style.bold]: props.bold })}>{props.grade}</div>
                    }
                    size={props.size ?? 36}
                    variant={"Square"}
                    backgroundColor={resolveColor(badgeColor)}
                />
            )}
            <Box columnLayout gap={"Xxxs"} className={classNames({ [style.details]: props.trailingContent })}>
                {props.title && (
                    <Heading variant="SUBTITLE_2" disableTopSpacing disableBottomSpacing>
                        {props.title}
                    </Heading>
                )}
                {props.description && <TextBlock disableBottomSpacing>{props.description}</TextBlock>}
            </Box>
            {props.trailingContent}
        </Box>
    );
};
